module.exports = __webpack_public_path__ + "img/img_17_retail@3x.e982fb87.png";